import moment from 'moment';

const { sysConfig, } = window as any;
const { tenMinsScalePermission, } = sysConfig;

/*
 * 权限设置--模糊查询：0 -精确查询：1 指定用户：2
 * 模糊查询：针对特定范围区域范围内所有用户（各级用户），进行设置，比如说焦作下所有用户 regionId.value.substr(0, 8);
 * 精确查询：针对指定区域用户，例如：高淳
 * 指定用户：指定登录用户，根据userId进行筛选
 */
// eslint-disable-next-line require-jsdoc
export function tenMinsPermByUser (item:any,userInfo:any):boolean {
  const { regionInfos, } = userInfo;

  const {
    regionLevel, id,
  } =
  regionInfos[0];

  switch (item.type) {
  case 0:
    if (id.substr(0, item.substr) === item.regionId) return true;
    break;
  case 1:
    if (id === item.regionId) return true;
    break;
  case 2:
    if (userInfo.id === item.userId) return true;
    break;
  default:
    return false;
  }

  return false;
}
export function getTimePlayerTenMinsPerm (userInfo:any):boolean {
  const arr = tenMinsScalePermission.filter((item:any) => {
    const flag = tenMinsPermByUser(item,userInfo);

    return flag;
  });

  return arr.length !== 0;
}

export const getMapZoom = (level: number) => {
  let mapZoom = 12;

  switch (level) {
  case 1:
    mapZoom = 7.5;
    break;
  case 2:
    mapZoom = 10;
    break;
  case 3:
    mapZoom = 12;
    break;
  default:
    mapZoom = 12;
    break;
  }

  return mapZoom;
};

// 通过regionInf信息获取地图缩放
export const getMapArea = (regionInfo: any) => {
  let mapArea = '';

  switch (regionInfo.regionLevel) {
  case 1:
    mapArea = regionInfo.province;
    break;
  case 2:
    mapArea = regionInfo.city;
    break;
  case 3:
    mapArea = regionInfo.county;
    if (mapArea === '高淳县') {
      mapArea = '高淳区';
    }
    break;
  default:
    mapArea = regionInfo.country;
    break;
  }

  return mapArea;
};

// 根据权限返回一张图缓存数据结构
export const getMultipleDataCaches = (grantList:any) :any => {
  const tmp :any = {
    weatherPM: { isChecked: false, data: {}, },
    diffDiagram: { isChecked: false, data: {}, },
    windy: { isChecked: false, data: {}, dataType: '', },
    exceed: {
      isChecked: false,
      data: {},
      types: ['company',
        'cookingFume',
        'construction',
        'repair',
        'yard',
        'park',
        'companyList',
        'cookingFumeList',
        'constructionList',
        'repairList',
        'yardList',
        'parkList',
        'muckParkList',],
    },
    pm: {
      isChecked: true,
      isDiffDiagramChecked: false,
      data: {},
      types: ['country',
        'province',
        'city',
        'micro',],
    },
  };

  if (!grantList || grantList.length === 0) {
    return tmp;
  }

  const grantListFlat :any[] = [];
  let isPM = false;

  grantList.forEach((item:any) => {
    const { buttonChildren, key, } = item;

    if (!buttonChildren || buttonChildren.length === 0) return;
    grantListFlat.push(...buttonChildren);

    if (key === 'pm') {
      isPM = true;
    }
  });

  // 如果没有pm权限，默认打开差值图
  if (!isPM) {
    tmp.diffDiagram.isChecked = true;
  }

  grantListFlat.forEach((item:any) => {
    const { key, } = item;

    if (!key) return;

    if (tmp.pm.types.includes(key)) {
      tmp.pm.data[key] = { isChecked: true, data: {}, };
    } else if (tmp.exceed.types.includes(key)) {
      tmp.exceed.data[key] = { isChecked: false, data: {}, };
      tmp[key] = { isChecked: false, data: {}, };
    } else {
      tmp[key] = { isChecked: false, data: {}, };
    }
  });

  return tmp;
};

// 校验
export class Validator {
  cache: any[] = [];

  strategies: any ={
    isNonEmpty (value:any, errorMsg:string) {
      if (value === '') {
        return errorMsg;
      }
    },
    minLength (value:any, length:number, errorMsg:string) {
      if (value.length < length) {
        return errorMsg;
      }
    },
    isMobile (value:string, errorMsg:string) {
      if (!(/(^1[3|5|8][0-9]{9}$)/).test(value)) {
        return errorMsg;
      }
    },
  };

  constructor () {
    this.cache = [];
  }

  /*
   * add (dom: any, rules: any) {
   *   for (let i = 0, rule; rule = rules[i++];) {
   *     (function (rule) {
   *       const strategyAry = rule.strategy.split(':');
   *       const { errorMsg, } = rule;
   */

  /*
   *       this.cache.push(() => {
   *         const strategy = strategyAry.shift();
   */

  /*
   *         strategyAry.unshift(dom.value);
   *         strategyAry.push(errorMsg);
   */

  /*
   *         return strategies[strategy].apply(dom, strategyAry);
   *       });
   *     }(rule));
   *   }
   * }
   */
}

// 初始化工单预计完成时间（延迟3天，跳过周末）
export const initHandleTimeLimitFn = () => {
  for (let num = 0; num < 4; num++) {
    const day = moment().add(num, 'days').get('weekday');

    // 是否周末
    const isWeekend = day === 5 || day === 6;

    // 周六/周日
    if (num === 0 && isWeekend) {
      return moment().add(2, 'days').startOf('week').add(3, 'days');
    }

    // 周三/周四/周五
    if (isWeekend) {
      return moment().add(5, 'days');
    }

    // 周一/周二
    if (num === 3 && !isWeekend) {
      return moment().add(3, 'days');
    }
  }
};
